import { render, staticRenderFns } from "./ProjectDetailsScreen.vue?vue&type=template&id=6b7b6409"
import script from "./ProjectDetailsScreen.vue?vue&type=script&lang=js"
export * from "./ProjectDetailsScreen.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetailsScreen.vue?vue&type=style&index=0&id=6b7b6409&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports